import React, { useEffect, useState } from 'react';
import noDicomIcon from '../../../assets/nodicom-icon.png';
import { getAtlasThumbnail, type AtlasCatalogItem } from '../../services/atlasService';

export default function AtlasThumbnail({
  atlas,
  token,
}: {
  atlas?: AtlasCatalogItem;
  token?: string | null;
}) {
  const key = `${atlas?.id}:${atlas?.content_version}:${token}`;
  const [preview, setPreview] = useState<{ key: string; url: string } | null>(null);

  useEffect(() => {
    if (!atlas || !token) return;
    const controller = new AbortController();
    let active = true;
    let objectUrl: string | undefined;
    getAtlasThumbnail(atlas, token, controller.signal)
      .then(blob => {
        if (!active) return;
        objectUrl = URL.createObjectURL(blob);
        setPreview({ key, url: objectUrl });
      })
      .catch(() => {
        if (active) setPreview(null);
      });
    return () => {
      active = false;
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [atlas?.id, atlas?.content_version, token]);

  const url = preview?.key === key ? preview.url : null;
  return (
    <img
      className={url ? 'pc-atlas-thumbnail' : 'dicom-thumb-fallback'}
      src={url ?? noDicomIcon}
      alt={url ? `${atlas?.name} axial preview` : 'No atlas image available'}
      draggable={false}
      onError={() => setPreview(null)}
    />
  );
}
